import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

type ScrollToAnchorProps = {
  smooth?: boolean;
};

export const useScrollToAnchor = ({
  smooth,
}: ScrollToAnchorProps): { scrollToAnchor: () => void } => {
  const location = useLocation();

  const scrollToAnchor = useCallback<() => void>(() => {
    const hash = location.hash.slice(1);
    const target = document.getElementById(hash);
    const position = (target?.offsetTop ?? 0) - 100;

    if (target) {
      setTimeout(() => {
        window.scroll({ top: target ? position : 0, behavior: smooth ? 'smooth' : 'auto'});
      }, 100);
    }
  }, [location, smooth]);

  return { scrollToAnchor };
};